/* global axios */
import ApiClient from './ApiClient';

class CompanyContactsAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  getUrl(companyId) {
    return `${this.url}/${companyId}/contacts`;
  }

  get(companyId) {
    return axios.get(this.getUrl(companyId));
  }

  show(companyId, companyContactId) {
    return axios.get(`${this.getUrl(companyId)}/${companyContactId}`);
  }

  create(companyId, { contactId, role, isPrimary }) {
    return axios.post(this.getUrl(companyId), {
      company_contact: {
        contact_id: contactId,
        role,
        is_primary: isPrimary,
      },
    });
  }

  update(companyId, companyContactId, { role, isPrimary }) {
    return axios.patch(`${this.getUrl(companyId)}/${companyContactId}`, {
      company_contact: {
        role,
        is_primary: isPrimary,
      },
    });
  }

  delete(companyId, companyContactId) {
    return axios.delete(`${this.getUrl(companyId)}/${companyContactId}`);
  }
}

export default new CompanyContactsAPI();
